export default __webpack_public_path__ + "static/media/yoox-logo.569cfd3f.png";